(() => {
  let initialized = false;

  const initialize = () => {
    if (initialized) return;

    const productInfo = document.querySelector('.product-info');
    const blockList = productInfo?.querySelector('.product-info__block-list');
    let priceBlock = blockList?.querySelector('[data-block-type="price"]');

    if (!productInfo || !blockList || !priceBlock) return;

    initialized = true;

    const findReviewBlock = () => Array.from(blockList.querySelectorAll('[data-block-type="@app"]')).find((block) =>
      block.querySelector('.jdgm-preview-badge, .jdgm-prev-badge')
    );

    let reviewBlock = findReviewBlock();

    let installmentNote = productInfo.querySelector('.fg-installment-note');
    let b20Note = productInfo.querySelector('.fg-b20-price-note');

    const keepSingleNote = (selector, preferredNote) => {
      const notes = Array.from(productInfo.querySelectorAll(selector));
      const activeNote = preferredNote?.isConnected ? preferredNote : notes[0] || null;

      notes.forEach((note) => {
        if (note !== activeNote) note.remove();
      });

      return activeNote;
    };

    const installmentTemplate = document.getElementById('fg-installment-template');
    const b20Markup = 'Use <button type="button" class="fg-discount-copy fg-discount-copy--inline" data-discount-copy="B20" aria-label="Tap to copy B20. Save $20 on orders of $80 or more."><span class="fg-discount-copy__default">B20</span><span class="fg-discount-copy__success" aria-hidden="true">Copied B20 ✓</span></button> at checkout · Save $20 on orders $80+';

    const shouldShowB20Note = () => Boolean(
      document.querySelector('quantity-selector[data-promo-code="B20"]')
    );

    const ensureB20Style = () => {
      if (document.getElementById('fg-b20-price-note-style')) return;

      const style = document.createElement('style');
      style.id = 'fg-b20-price-note-style';
      style.textContent = `
        .fg-price-notes .fg-b20-price-note,
        .product-info .fg-b20-price-note {
          margin: 4px 0 0;
          color: #73591f;
          font-size: 12px;
          font-weight: 600;
          line-height: 1.3;
        }

        .fg-b20-price-note .fg-discount-copy {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 22px;
          padding: 1px 7px;
          border: 1px dashed rgba(184, 155, 72, 0.58);
          border-radius: 4px;
          background: rgba(184, 155, 72, 0.08);
          color: #73591f;
          font: inherit;
          font-weight: 700;
          line-height: 1.2;
          cursor: pointer;
          appearance: none;
        }

        .fg-b20-price-note .fg-discount-copy__success {
          display: none;
        }

        .fg-b20-price-note .fg-discount-copy.is-copied .fg-discount-copy__default {
          display: none;
        }

        .fg-b20-price-note .fg-discount-copy.is-copied .fg-discount-copy__success {
          display: inline;
        }
      `;
      document.head.appendChild(style);
    };

    const ensureB20Note = () => {
      if (!shouldShowB20Note()) return null;

      ensureB20Style();

      if (!b20Note) {
        b20Note = document.createElement('p');
        b20Note.className = 'fg-b20-price-note';
        b20Note.innerHTML = b20Markup;
      } else if (!b20Note.querySelector('[data-discount-copy="B20"]')) {
        b20Note.innerHTML = b20Markup;
      }

      return b20Note;
    };

    if (!installmentNote) {
      installmentNote = document.createElement('p');
      installmentNote.className = 'fg-installment-note';
    }

    if (installmentTemplate && !installmentNote.querySelector('.fg-installment-copy')) {
      installmentNote.replaceChildren(installmentTemplate.content.cloneNode(true));
    }

    const formatInstallment = (priceInCents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      const locale = document.documentElement.lang || 'en-US';

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format(priceInCents / 400);
    };

    const readDisplayedPrice = () => {
      const salePrice = priceBlock.querySelector('sale-price');
      const text = salePrice?.textContent || '';
      const normalized = text.replace(/[^0-9.,]/g, '').replace(/,/g, '');
      const value = Number.parseFloat(normalized);
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    };

    const updateAmount = (priceInCents) => {
      const amount = installmentNote.querySelector('[data-fg-installment-amount]');
      const resolvedPrice = Number.isFinite(priceInCents) ? priceInCents : readDisplayedPrice();
      const hasPayablePrice = Number.isFinite(resolvedPrice) && resolvedPrice > 0;

      installmentNote.hidden = !hasPayablePrice;
      installmentNote.style.display = hasPayablePrice ? '' : 'none';

      if (amount) {
        const nextAmount = hasPayablePrice ? formatInstallment(resolvedPrice) : '';
        if (amount.textContent !== nextAmount) {
          amount.textContent = nextAmount;
        }
      }
    };

    const restoreLayout = () => {
      priceBlock = blockList.querySelector('[data-block-type="price"]') || priceBlock;
      reviewBlock = findReviewBlock() || reviewBlock;
      installmentNote = keepSingleNote('.fg-installment-note', installmentNote) || installmentNote;
      if (installmentTemplate && !installmentNote.querySelector('.fg-installment-copy')) {
        installmentNote.replaceChildren(installmentTemplate.content.cloneNode(true));
      }
      b20Note = keepSingleNote('.fg-b20-price-note', b20Note);

      let row = priceBlock.closest('.fg-price-with-reviews');

      if (reviewBlock && !row) {
        row = document.createElement('div');
        row.className = 'product-info__block-group text-with-rating fg-price-with-reviews';
        row.dataset.groupType = 'text-with-rating';
        blockList.insertBefore(row, priceBlock);
        row.append(priceBlock, reviewBlock);
      } else if (reviewBlock && reviewBlock.parentElement !== row) {
        row.append(reviewBlock);
      }

      const activeB20Note = ensureB20Note() || priceBlock.querySelector('.fg-b20-price-note');
      const priceList = priceBlock.querySelector('price-list, .price-list');
      const noteIsInsidePrice = priceBlock.contains(installmentNote);

      if (row && (activeB20Note || noteIsInsidePrice || !installmentNote.isConnected)) {
        let notes = blockList.querySelector(':scope > .fg-price-notes');

        if (!notes) {
          notes = document.createElement('div');
          notes.className = 'fg-price-notes';
          row.insertAdjacentElement('afterend', notes);
        }

        if (installmentNote.parentElement !== notes) {
          notes.append(installmentNote);
        }

        if (activeB20Note && activeB20Note.parentElement !== notes) {
          notes.append(activeB20Note);
        }
      } else if (!row && priceList && !installmentNote.isConnected) {
        priceList.insertAdjacentElement('afterend', installmentNote);
      }

      updateAmount();
    };

    restoreLayout();

    let restoreScheduled = false;
    const observer = new MutationObserver(() => {
      if (restoreScheduled) return;

      restoreScheduled = true;
      requestAnimationFrame(() => {
        restoreScheduled = false;
        restoreLayout();
      });
    });
    observer.observe(productInfo, { childList: true, subtree: true });

    document.addEventListener('variant:change', (event) => {
      const variantPrice = event.detail?.variant?.price;
      updateAmount(variantPrice);
      requestAnimationFrame(() => requestAnimationFrame(restoreLayout));
      setTimeout(restoreLayout, 150);
    });
  };

  initialize();
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  setTimeout(initialize, 250);
  setTimeout(initialize, 1000);
})();
